import React, { useState } from 'react'
import { Modal } from 'antd'
import classNames from 'classnames'
import { Search } from '../../../components'

const AddUsers = ({ active, onCancel, onOk, users }) => {
  let [select, setSelect] = useState([])
  const [search, setSearch] = useState('')
  const submit = () => {
    if (select) {
      onOk(select)
      setSelect([])
    }
  }

  const validationSelect = (index) => {
    return select.indexOf(index) > -1
  }

  const onSelect = (index) => {
    if (!validationSelect(index)) {
      setSelect([...select, index])
    } else {
      setSelect([...select.filter(sel => sel !== index)])
    }
  }

  const onSearch = (s) => {
    setSearch(s)
  }
  if (!active) {
    return null
  }
  return (
    <Modal
      title="Add users"
      visible={active}
      onCancel={onCancel}
      closable={false}
      width={410}
      footer={[
        <button key="submit" className={'btn btn-secondary dart-btn'}
                style={{ width: 125 }} onClick={submit}>
          Ok
        </button>,
        <button key="back"
                className={'btn btn-outline-secondary dart-btn-outline'}
                style={{ width: 125 }}
                onClick={onCancel}>Cancel</button>,
      ]}
    >
      <Search onSubmit={onSearch}/>
      <div
        className={'knackly-plain rounded py-1 px-2 border border-dark my-2 w-100'}
        style={{
          height: '20rem',
          overflow: 'auto',
        }}
      >
        {users.filter(user => !search
          || user.name.toUpperCase().includes(search.toUpperCase())
          || user.mail &&
          user.mail.toUpperCase().includes(search.toUpperCase())).
          map((user, index) => (
            <div key={'addUser' + user.name + index}
                 onClick={() => onSelect(user._id)}
                 className={classNames(
                   'rounded cursorPointer py-1 px-2 border d-flex justify-content-between my-1',
                   { 'knackly-back-light': validationSelect(user._id) })}>
              <div>{user.name ? user.name : user.mail}</div>
              <div>{user.isAdmin ? 'Admin' : 'User'}</div>
            </div>),
          )}
      </div>

    </Modal>
  )
}

export default AddUsers
